import { Component } from 'react'
import * as styles from 'components/features/socialFeed/FeedPost/FeedPost.styl'
import { FeedPostMeta } from 'components/features/socialFeed/FeedPost/FeedPostMeta'
import { FeedPostText } from 'components/features/socialFeed/FeedPost/FeedPostText'
import FeedPostHeaderContainer from 'components/features/socialFeed/FeedPost/FeedPostHeaderContainer'
import { PostUidOwnProps } from 'selectors/feedSelectors'
import { Post, FeedUser, ComposeId } from 'interfaces/feed'
import { Compose } from 'components/features/socialFeed/Compose/Compose'
import AttachmentsBlock from 'components/features/socialFeed/FeedPost/AttachmentsBlock'
import { ImageURLs } from 'interfaces/media'
import { PostLayout } from 'components/features/pfm/PostLayout/PostLayout'
import { getEditPostComposeId, parseText, Decoration } from 'helpers/composeHelpers'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'
import { defaultMemoize } from 'reselect'
import { SocialInsight } from 'interfaces/socialInsights'
import { FeedPostImpressionHandler } from 'components/features/socialFeed/FeedPostImpressionHandler/FeedPostImpressionHandler'

export type FeedPostStateProps = {
  post: Exclude<Post, SocialInsight>
  images: ImageURLs[]

  author: FeedUser | null
  isLikeLoading: boolean
  isPostFollowLoading: boolean
  isPostEditing: boolean
}

export type FeedPostDispatchProps = {
  onPostEdit: (isEditing: boolean) => void
  onCancelEdit: (composeId: ComposeId) => void
}

export type FeedPostOwnProps =
  & PostUidOwnProps
  & {
    singlePostPage?: boolean
  }


type FeedPostProps =
  & FeedPostStateProps
  & FeedPostDispatchProps
  & FeedPostOwnProps

class FeedPost extends Component<FeedPostProps> {

  render () {
    const {
      isPostEditing,
      postUid,
      post,
      author,
      singlePostPage,
    } = this.props

    const decorations = parseText(post.text, 'post')
    const tags = this.getTagsTitle(decorations, post.text)

    return (
      <FeedPostImpressionHandler postUid={ postUid }>
        <PostLayout
          postUid={ postUid }
          header={ (
            <FeedPostHeaderContainer
              userUid={ post.authorUid }
              postUid={ postUid }
            />
          ) }
        >
          { singlePostPage && (
            <PageMeta
              title={ `${ author ? author.username : '' } on Status Money: ${ post.text }${ tags && ` | ${ tags }` }` }
              description={ post.text }
            />
          )}
          { isPostEditing && this.renderEditing() }
          { !isPostEditing && this.renderPost() }
        </PostLayout>
      </FeedPostImpressionHandler>
    )
  }

  private renderPost () {
    const {
      post,
      images,
    } = this.props

    return (
      <article>
        <FeedPostText className={ styles.text } text={ post.text } mentions={ post.mentions } mode='post' />
        <AttachmentsBlock images={ images } links={ post.links } mode='post' />
        <FeedPostMeta postUid={ post.uid } />
      </article>
    )
  }

  private renderEditing () {
    const {
      post,
    } = this.props

    return (
      <Compose
        composeId={ getEditPostComposeId(post.uid) }
        isEdit
        postUid={ post.uid }
        onDone={ this.handleEditCancel }
        focusOnMount
      />
    )
  }

  private getTagsTitle = defaultMemoize((decorations: Decoration[], text: string) => {
    return decorations
      .filter((item) => item.type === 'tag')
      .map((item) => text.substring(item.start, item.end))
      .slice(0, 3)
      .join(' ')
  })

  private handleEditCancel = () => {
    const { post, onPostEdit, onCancelEdit } = this.props
    onPostEdit(false)
    onCancelEdit(getEditPostComposeId(post.uid))
  }

}

export default FeedPost
